<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">
  <div class="container-fluid">
    <div class="card ">
      <div class="row">
        <div class="col-12">
          <div class="card card-outeline-primary">
            <div class="card-header">
              <p class="headText1 text-danger"><i class="fas fa-user-check"></i> ขอปุ๋ยรอบ3 ปีการผลิต 2566/2567</p>
              <div class="card-tools">
                <!-- <button type="button" class="btn btn-tool" data-card-widget="card-refresh" data-source="widgets.html" data-source-selector="#card-refresh-content" data-load-on-init="false"><i class="fas fa-sync-alt"></i></button> -->
                <button type="button" class="btn btn-tool" data-card-widget="maximize"><i
                    class="fas fa-expand"></i></button>
                <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                    class="fas fa-minus"></i></button>
                <!-- <button type="button" class="btn btn-tool" data-card-widget="remove"><i class="fas fa-times"></i></button> -->
              </div>
              <div class="row">
                <div class="col-12">
                  <form #frm_search="ngForm" class="form-inline mt-2">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">โควตา10หลัก</span>
                        </div>
                        <input #fmcode="ngModel" ngModel name="fmcode" class="form-control" id="fmcode"
                          [ngModel]="fmcodeselect"
                          [ngClass]="{'is-invalid' : fmcode.invalid && (fmcode.dirty || fmcode.touched)}" minlength="10"
                          maxlength="10" required>
                        <div class="invalid-feedback">
                          <span *ngIf="fmcode.hasError('required','minlength','maxlength')">ป้อนโควตา 10 หลัก</span>
                        </div>
                        <button [disabled]="frm_search.invalid" (click)="cpGetfert3(frm_search.value.fmcode)"
                          type="submit" class="btn btn-outline-primary"><i class="fas fa-search"></i> Search </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.card-header -->
            <p class="headText1 text-primary mt-2 ml-2"><i class="fas fa-tree"></i> ข้อมูลแปลง </p>
            <div class="card-body table-responsive p-2" style="height: 400px">
              <table #tb_data class="table table-hover table-head-fixed text-nowrap table-sm">
                <thead>
                  <tr class="headText text-primary">
                    <th>เลขแปลง</th>
                    <th>ชื่อชาวไร่</th>
                    <th>ข้อมูลแปลง</th>
                    <th class="text-center">ขอได้</th>
                    <th class="text-center">เบิกไปแล้ว</th>
                    <th class="text-center">เบิกได้อีก</th>
                    <th class="text-center"><i class="fab fa-wpforms"></i></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of cpdata"
                    [ngClass]="[item.schedule == 1 && item.status_sv != 5 ? 'bg-warning' : '']">
                    <td>{{ item.intlandno }}</td>
                    <td><b class="text=primary">{{ item.fmname }}</b> </td>
                    <td>
                      {{ item.canetype }} {{ item.landvalue }} ไร่ รูท {{ item.route }} โซน {{ item.supzone }}
                    </td>
                    <td class="text-center">{{ item.caneGetfert3 }}</td>
                    <td class="text-center">{{ item.Getferted }}</td>
                    <td class="text-center">{{ item.balance_fert3 }}</td>
                    <td class="text-center text-primary">
                      <i *ngIf="item.caseOK =='Y' && item.balance_fert3>0" (click)="modalGetfert3(item.itid)"
                        data-bs-toggle="modal" data-bs-target="#md_getfert3" title="ฟอร์มขอปุ๋ยรอบ3"
                        class="fab fa-wpforms"></i>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>          
            
            <p class="headText1 text-primary ml-2 mt-2"><i class="fas fa-history"></i> รายการเบิกปุ๋ยรอบ 3 ของชาวไร่
            </p>
            <div class="card-body table-responsive p-2" style="height: 400px">
              <table #tb_fmgetFactor class="table table-hover table-head-fixed text-nowrap">
                <thead>
                  <tr class="headText text-primary">
                    <th>วันที่</th>
                    <th>เลขคำขอ</th>
                    <th>แปลง</th>
                    <th>รายการเบิกปุ๋ย</th>
                    <th class="text-right">จำนวน</th>
                    <th class="text-center"><i class="fas fa-print"></i></th>
                    <th class="text-center">ยกเลิก</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of fmgetFactorNow">
                    <td>{{ item.datepost | adtob }}</td>
                    <td>{{ item.docid }}</td>
                    <td>{{ item.intlandno }}</td>
                    <td>{{ item.desc1 }}</td>
                    <td class="text-right">{{ item.amt1 }}</td>
                    <td class="text-center text-primary">
                      <a *ngIf="item.getFert3 === 'Y'"
                        [routerLink]="['/docfertilizer/6667/'+item.fmcode+'/'+item.docid+'/0']"
                        routerLinkActive="active" target="_blank" title="พิมพ์ใบจ่ายปุ๋ย">
                        <i class="fas fa-print"></i>
                      </a>
                    </td>
                    <td class="text-center">
                      <a *ngIf="item.doc_print=='0'" (click)="cancledata(item.docid)"> <i class="far fa-window-close"
                          style='color:red'></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- /.card-body -->
          </div>

          <!-- Modal ฟอร์มขอปุ๋ยรอบ3 -->
          <div class="modal fade" id="md_getfert3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content" *ngFor="let item of cpbyone">
                <form #frm_getFert3="ngForm" class="form-inline">
                  <div class="modal-header">
                    <blockquote class="blockquote">
                      <p>แปลง {{ item.intlandno }} {{ item.canetype }} {{ item.landvalue }} ไร่ รูท {{ item.route }}
                      </p>
                      <footer class="blockquote-footer text-primary headText1">{{ item.fmname }}</footer>
                      <p class="headText">
                        ขอได้ <span class="badge rounded-pill bg-success headText"> {{ item.caneGetfert3 }} </span>
                        ขอไปแล้ว <span class="badge rounded-pill bg-info headText"> {{ item.Getferted }} </span>
                        ขอได้อีก <span class="badge rounded-pill bg-warning headText1"> {{ item.balance_fert3 }} </span>
                      </p>
                      <!-- <p> itid : {{ item.itid }} </p> -->
                    </blockquote>
                    <input #hitid="ngModel" ngModel name="hitid" [(ngModel)]="item.itid" class="form-control"
                      type="hidden">
                    <input #hintlandno="ngModel" ngModel name="hintlandno" [(ngModel)]="item.intlandno"
                      class="form-control" type="hidden">
                    <input #hsupcode="ngModel" ngModel name="hsupcode" [(ngModel)]="supcodeselect" class="form-control"
                      type="hidden">
                    <input #hfmcode="ngModel" ngModel name="hfmcode" [(ngModel)]="item.fmcode" class="form-control"
                      type="hidden">
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text"> <i class="fas fa-home"> สต็อค </i></span>
                          </div>
                          <select [(ngModel)]="Stockselect" #stockid="ngModel" ngModel name="stockid"
                            (ngModelChange)="sum_money_amt(frm_getFert3.value)" type="text" class="form-control"
                            [ngClass]="{'is-invalid' : stockid.invalid && (stockid.dirty || stockid.touched)}" required>
                            <option value="" disabled>++สต็อคปุ๋ย++</option>
                            <option *ngFor="let item of StockData" [value]="item.StockID">{{ item.Stockname }}</option>
                          </select>
                          <div class="invalid-feedback">
                            <span *ngIf="stockid.hasError('required')">ต้องสต็อคปุ๋ย</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text"> <i class="fas fa-list-ol"> สูตร </i></span>
                          </div>
                          <select #get1="ngModel" ngModel name="get1" type="text" class="form-control"
                            [ngClass]="{'is-invalid' : get1.invalid && (get1.dirty || get1.touched)}"
                            (ngModelChange)="sum_money_amt(frm_getFert3.value)" required>
                            <option value="" disabled>++สูตรปุ๋ย++</option>
                            <option *ngFor="let item of chemicaData" [value]="item.stock_id">{{ item.stock_id }} {{
                              item.description }}</option>
                          </select>
                          <div class="invalid-feedback">
                            <span *ngIf="get1.hasError('required')">เลือกสูตรปุ๋ย</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text"> <i class="fas fa-user-edit"> จำนวนที่ขอเบิก </i></span>
                          </div>
                          <input #amt1="ngModel" ngModel name="amt1" type="number" min="1" class="form-control" required
                            [ngClass]="{'is-invalid' : amt1.invalid && (amt1.dirty || amt1.touched ) }"
                            [ngModel]="item.balance_fert3" (ngModelChange)="sum_money_amt(frm_getFert3.value)">
                          <div class="invalid-feedback">
                            <span *ngIf="amt1.hasError('required')">กรอกจำนวนที่ขอ ไม่เกินที่ขอได้</span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <!--<span class="input-group-text"> <i class="fas fa-user-edit"> ราคารวม <b>{{money_amt | number}}</b> บาท</i></span>-->
                            <span class="input-group-text"> <i class="fas fa-atlas"> ราคารวม <span
                                  class="badge badge-primary">{{money_amt | number}}</span><span class="sr-only">unread
                                  messages</span> บาท</i></span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text"> <i class="	fab fa-amazon-pay"> วิธีการเบิก </i></span>
                          </div>
                          <select [ngModel]="0" #take_method="ngModel" ngModel name="take_method" type="text"
                            class="form-control"
                            [ngClass]="{'is-invalid' : take_method.invalid && (take_method.dirty || take_method.touched)}"
                            required>
                            <option value="" disabled>++การเบิก++</option>
                            <option value="0" selected>เงินเชื่อ</option>
                            <option value="1">ซื้อเงินสด</option>
                          </select>
                          <div class="invalid-feedback">
                            <span *ngIf="take_method.hasError('required')">ต้องเลือกวิธีการเบิก</span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="modal-footer">
                    <!-- <blockquote class="blockquote">
                      <p>{{ frm_getFert3.value | json }}</p>
                      <footer class="blockquote-footer">From WWF's website</footer>
                    </blockquote> -->
                    <button class="btn btn-primary" type="submit" [disabled]="frm_getFert3.invalid"
                      (click)="saveGetfert3(frm_getFert3.value);"><i class="fas fa-save"> บันทึก </i>
                    </button>
                    <button type="button" class="btn btn-warning" data-bs-dismiss="modal" aria-label="Close"
                      (click)="closemodel();"><i class="	fas fa-sign-out-alt"> ปิด </i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- / Modal ฟอร์มขอปุ๋ยรอบ3 -->

        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>